/**
 * Environment configuration for the application.
 * These values are replaced at build time by Vite.
 */

interface EnvironmentConfig {
  apiBaseUrl: string;
  environment: 'development' | 'qa' | 'uat' | 'production';
  debug: boolean;
}

const config: EnvironmentConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  environment: (import.meta.env.VITE_APP_ENVIRONMENT || 'development') as EnvironmentConfig['environment'],
  debug: import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true',
};

// Validate required configuration
if (!config.apiBaseUrl) {
  throw new Error('VITE_API_BASE_URL environment variable is not defined');
}

// Log configuration in non-production environments
if (config.environment !== 'production' && config.debug) {
  console.log('Environment Configuration:', {
    apiBaseUrl: config.apiBaseUrl,
    environment: config.environment,
  });
}

export default config;
